define.alias("ember-functions-as-helper-polyfill/initializers/usable-function-manager", "calendar/initializers/usable-function-manager");